import classNames from 'classnames'
import React, { ReactNode } from 'react'
import './widget.scss'

export function Widget({
  title,
  children,
  className,
  updateSignal,
  color,
  ...props
}: {
  title?: ReactNode
  updateSignal?: number
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>) {
  const [isHighlighted, setIsHighlighted] = React.useState(false)

  const firstRender = React.useRef(true)
  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }

    setIsHighlighted(true)
    const timer = setTimeout(() => {
      setIsHighlighted(false)
    }, 500)
    return () => clearTimeout(timer)
  }, [updateSignal])

  return (
    <div
      className={classNames(
        'poe-widget',
        isHighlighted && 'poe-highlight',
        className
      )}
      {...props}>
      {!!title && (
        <span className="poe-title">
          {!!color && (
            <span
              className="poe-widget-color"
              style={{ backgroundColor: color }}></span>
          )}
          {title}
        </span>
      )}
      <div className="poe-content">{children}</div>
    </div>
  )
}
